import React from 'react';

type Props = {
  className?: string;
  dimension?: number;
};

const Icon: React.FC<Props> = ({className=''}: Props) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={className} width="16" height="16" viewBox="0 0 16 16" fill="none">
  <mask id="mask0_18400_32486" style={{maskType:'alpha'}} maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
    <rect width="16" height="16" fill="#D9D9D9"/>
  </mask>
  <g mask="url(#mask0_18400_32486)">
    <path d="M5.35033 14.6663L4.16699 13.483L9.65033 7.99967L4.16699 2.51634L5.35033 1.33301L12.017 7.99967L5.35033 14.6663Z" fill="#01916D"/>
  </g>
</svg>
);

export default Icon;
